function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconHistory = function SvgIconHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    width: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.07868 3.06891C6.87402 -0.721068 13.0437 -0.68077 16.8622 3.13778C20.6824 6.95797 20.7211 13.1313 16.9262 16.9262C13.1312 20.7211 6.95793 20.6824 3.13774 16.8622C0.873887 14.5984 -0.060962 11.5099 0.34047 8.58123C0.39672 8.17085 0.774996 7.88377 1.18537 7.94002C1.59575 7.99627 1.88282 8.37455 1.82658 8.78493C1.4866 11.2652 2.27782 13.881 4.1984 15.8016C7.44288 19.0461 12.6664 19.0646 15.8655 15.8655C19.0646 12.6664 19.046 7.44292 15.8015 4.19844C12.5587 0.955615 7.33889 0.93539 4.13935 4.12957L4.88705 4.13333C5.30126 4.13541 5.63535 4.47288 5.63327 4.88709C5.63119 5.3013 5.29372 5.63539 4.87951 5.63331L2.33396 5.62052C1.92269 5.61845 1.58981 5.28556 1.58774 4.8743L1.57495 2.32874C1.57286 1.91454 1.90696 1.57707 2.32117 1.57498C2.73538 1.5729 3.07285 1.907 3.07493 2.32121L3.07868 3.06891ZM9.99988 5.24992C10.4141 5.24992 10.7499 5.58571 10.7499 5.99992V9.68926L13.0302 11.9696C13.3231 12.2625 13.3231 12.7374 13.0302 13.0302C12.7373 13.3231 12.2624 13.3231 11.9696 13.0302L9.24988 10.3106V5.99992C9.24988 5.58571 9.58567 5.24992 9.99988 5.24992Z"
  }));
};
export default SvgIconHistory;